import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useScroll, useTransform } from "framer-motion";
import { Link } from 'react-router-dom';
import "../components/styles/homepage.css";

const HomePage = ({ backgroundImage = "/Herobg2.png" }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Add this state
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, -50]);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const { scrollYProgress } = useScroll();
  const parallaxY = useTransform(scrollYProgress, [0, 1], ['0%', '40%']);
  const [currentSlide, setCurrentSlide] = useState(0);
  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => 
        prevSlide === testimonials.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000); // Rotate every 5 seconds

    return () => clearInterval(timer);
  }, []);

  const handleLogoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setActiveDropdown(null);
  };

  const services = [
    {
      title: "Weddings",
      description: "Perfect your special day with our expert bridal makeup services.",
      image: "./Makeup3.jpg",
      href: "/wedding"
    },
    {
      title: "Editorial",
      description: "Stand out at any occasion with our professional makeup artistry.",
      image: "./Makeup2.jpg",
      href: "/editorial"
    },
    {
      title: "Glam",
      description: "Create stunning looks for photoshoots and professional media.",
      image: "./Makeup19.jpg",
      href: "/glam"
    }
  ];
  const portfolioItems = [
    {
      id: 1,
      image: './makeup13.jpg',
      alt: 'Bridal makeup look'
    },
    {
      id: 2,
      image: './Makeup1.jpg',
      alt: 'Glamour makeup'
    },
    {
      id: 3,
      image: './makeup15.jpg',
      alt: 'Editorial beauty'
    },
    {
      id: 4,
      image: './makeup11.jpg',
      alt: 'Natural makeup look'
    },
    {
      id: 5,
      image: './makeup10.jpg',
      alt: 'Evening makeup'
    },
    {
      id: 6,
      image: './makeup16.jpg',
      alt: 'Special event makeup'
    },
    {
      id: 7,
      image: './makeup25.jpg',
      alt: 'Special event makeup'
    },
    {
      id: 8,
      image: './Makeup34.jpg',
      alt: 'Special event makeup'
    },
    {
      id: 9,
      image: './makeup18.jpg',
      alt: 'Special event makeup'
    },
    {
      id: 10,
      image: './Makeup26.jpg',
      alt: 'Special event makeup'
    }
  ];
    const testimonials = [
      {
        id: 1,
        logo: "/butterfly.png",
        quote: "Lorren is an amazing makeup artist! She matched my skin tone perfectly, creating a flawless look that felt natural and beautiful. Her attention to detail is incredible, and her gentle touch made the entire experience so relaxing. I truly felt like the best version of myself. If you're looking for a talented and professional makeup artist, Lorren is the one!",
        author: "Natasha",
        position: "Glam",
        image: "/Makeup22.jpg"
      },
      {
        id: 2,
        logo: "/butterfly.png",
        quote: "Lorren is very professional and artistic when it comes to applying makeup and skincare products. The products she uses help to cover blemishes and keep the skin looking flawless. I love the fact that she can take tough criticism and feedback and that Lorren is very dedicated, empathetic, kind, and an inspirational individual who is excellent at doing makeup.",
        author: "Rebekah",
        position: "Bridal",
        image: "/makeup11.jpg"
      },
      {
        id: 3,
        logo: "/butterfly.png",
        quote: "Lorren's skills and expertise made me feel extremely special for my event, the makeup lasted the whole day right until the nighttime event ended and Lorren was able to achieve the exact look I envisioned for the specific event. Not to mention, Lorren is very friendly, kind, and patient and lets you as the client have your say in each step of the process.",
        author: "Sanjana",
        position: "Glam",
        image: "/makeup16.jpg"
      },
      {
        id: 3,
        logo: "/butterfly.png",
        quote: "Thank you for the makeup! I love it. I feel so pretty!! You're also very kind and talented.",
        author: "Alexa",
        position: "Glam",
        image: "/Makeup23.jpg"
      }
    ];
  const handleDropdownClick = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };
  

  return (
    <>
      <div className="relative h-screen overflow-hidden">
        {/* Background Image Layer */}
        <div className="absolute inset-0">
          <img 
            src={backgroundImage}
            alt="Background"
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        
        
        
        {/* Main Content */}
        <div className="relative h-full max-w-6xl mx-auto px-8 py-12 flex items-center z-20">
          <div className="w-full">
            <h1 className="hero-title">
              Makeup By Lorren
            </h1>
            <div className="hero-container">
            </div>
            <div className="hero-cta-container">
              <span className="hero-text-bottom"></span>
              <br />
              <span className="hero-text-bottom2"></span>
              <Link to="/booking" className="hero-button">
                Book Now
              </Link>
            </div>
          </div>
        </div>

        {/* Vertical Text */}
        <div className="absolute top-0 right-0 w-32 h-full flex flex-col justify-center items-center text-white tracking-widest transform rotate-180 z-20">
        </div>
      </div>

      {/* Services Section */}
      <section className="services" id="services">
    
      <div className="container">
        <div className="services-intro">
          <h2>Artists Vision</h2>
          <p>
            "To merge artistry and precision, empowering individuals to express their unique beauty with
            confidence. By combining my analytical mindset and creative passion, I aim to offer
            personalized, transformative makeup experiences that cater to each client's individual style and
            needs. My vision is to build a trusted brand that not only enhances physical appearance but also
            inspires self-assurance, celebrating the beauty in every face."
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service) => (
            <a 
              href={service.href}
              key={service.title}
              className="service-link"
            >
              <motion.div
                className="service-card"
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="service-image-container">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-image"
                  />
                  <div className="service-title">
                    {service.title}
                  </div>
                </div>
              </motion.div>
            </a>
          ))}
        </div>
      </div>
    </section>

      {/* First Parallax Section */}
    <section className="parallax-section">
      <motion.div
        className="parallax-background"
        style={{ y: parallaxY }}
      >
        <video
          src="/Brushvid.mp4"
          className="parallax-image"
          autoPlay
          muted
          loop
          playsInline
        />
      </motion.div>
      <div className="parallax-text">
        <h2>Transform Your Look</h2>
        <p>Experience the magic of professional makeup artistry</p>
      </div>
    </section>

      {/* Second Parallax Section */}
      <section className="parallax-section2">
  <motion.div 
    className="parallax-background2"
    style={{ y: parallaxY }}
  >
    <img
      src="/swachbg.png"
      alt="Parallax background2"
      className="parallax-image2"
    />
  </motion.div>
  
  <div className="parallax-content">
    <div className="testimonials-section">
      <h2 className="testimonials-title">Our Clients Love Us</h2>
      
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div 
            key={testimonial.id} 
            className="testimonial-card"
            style={{
              display: index === currentSlide ? 'block' : 'none',
              opacity: index === currentSlide ? 1 : 0,
              transition: 'opacity 0.5s ease-in-out'
            }}
          >
            <img 
              src={testimonial.logo}
              alt="Company logo"
              className="company-logo"
            />
            <div className="quote-mark">"</div>
            <p className="testimonial-quote">{testimonial.quote}</p>
            <div className="testimonial-author">
              <img 
                src={testimonial.image}
                alt={testimonial.author}
                className="author-image"
              />
              <div className="author-info">
                <h4 className="author-name">{testimonial.author}</h4>
                <p className="author-position">{testimonial.position}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>
    </div>
  </div>
</section>
<section className="portfolio" id="portfolio">
        <div className="container">
          <h2>Here is Some Of Our Work</h2>
          <div className="portfolio-grid">
            {portfolioItems.map((item) => (
              <motion.div
                key={item.id}
                className="portfolio-item"
                whileHover={{ scale: 1.05 }}
              >
                <img
                  src={item.image}
                  alt={item.alt}
                  className="portfolio-image"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <section className="shop-section">
        <div className="shop-container">
          <div className="shop-content">
            <h2 className="shop-title">
              We Are Here For All Your  Makeup Needs
            </h2>
            
            <p className="shop-description">
              We offer free consultations, so don't be afraid to reach out and ask questions.
            </p>
            
            <a href="/contact">
  <button className="shop-button">CONTACT US!</button>
</a>
          </div>
        </div>
      </section>
      <section className="pre-contact" id="pre-contact">
        <div className="container">
          <div className="pre-contact-content">
            <h2>Our Mission</h2>
            <p>
              "To provide personalized, high-quality makeup artistry that enhances each client's natural
              beauty, boosts their confidence, and creates unforgettable looks, all while combining my
              analytical skills and creative passion."
            </p>
            <p>
              Contact us below to start your journey to looking and feeling your absolute best.
              We can't wait to be part of your special moment!
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;